import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { TokenizationBootstrapService } from '../../services/tokenization-bootstrap.service';

@Component({
  selector: 'app-blank-iframe',
  template: `
    <p> </p>
  `,
  styles: [
  ]
})
export class BlankIframeComponent {
  private unsubscriber: Subject<void> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private tokenizationBootstrap: TokenizationBootstrapService,
  ) {
    this.tokenizationBootstrap.subscribeToQueryParams(this.route, this.unsubscriber);
  }

  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
